<app-auth-header></app-auth-header>
<app-auth-sidebar></app-auth-sidebar>
<router-outlet></router-outlet>